import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-angular-three-sided',
  templateUrl: './curtain-angular-three-sided.component.html',
  styleUrls: ['./curtain-angular-three-sided.component.scss']
})
export class CurtainAngularThreeSidedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
